/*global $, Foundation */
import { TimelineMax, Power4 } from 'gsap';

import { createElement } from 'rlink-react';

import scrollToSection from 'helpers/scrolling/scrollToSection';
import contentLoader from 'helpers/contentLoader';
import BackToTopButton from 'components/buttons/BackToTopButton';
import IconRelicLogoFull from 'components/svg/iconRelicLogoFull';
import IconEssence from 'components/svg/iconEssence';

const onFooterLinkClick = function (e, timelineObj) {
  e.preventDefault();
  $('body').removeClass('noScroll');
  let id = $(e.target).attr('href').replace('/', '');
  if ($(id).length > 0) {
    window.hashTrack = true;
    scrollToSection(id, true, false, 2);
  }
  timelineObj.timeScale(2).reverse();
};

const initTimelineObj = function () {
  if (typeof document !== 'undefined') {
    return new TimelineMax({ paused: true })
      .fromTo(Foundation.utils.S('.top-bar-section'), 0.5, { autoAlpha: 0 }, { autoAlpha: 1 })
      .staggerFromTo(Foundation.utils.S('#main-menu li a'), 0.5, { y: -50, scale: 0.3, autoAlpha: 0 }, { y: 0, scale: 1, autoAlpha: 1, ease: Power4.easeOut }, 0.08, '-=0.5');
  } else {
    return {};
  }
};

export default function Footer () {
  const timelineObj = initTimelineObj();
  return (
    <footer id="footer" className="l-footer layout-standard" role="contentinfo">
      <BackToTopButton />
      <div className="wrapper">
        <div className="row">
          <div className="small-12  column small-centered">
            <div className="bottom row" role="contentinfo">
              <div className="bottom-one large-6 medium-8 small-12 columns">
                <section className="block block-block block-footer block-block-1">
                  <div className="contact clearfix">
                    <div className="map" />
                    <div className="address">
                      <h5 className="noline">Relic Entertainment</h5>285 W 5th Ave&#13;
                    <br />Vancouver&#13;
                    <br />BC V5Y 1J3&#13;
                    <br />Canada&#13;
                    <br />
                      <strong>Phone</strong>: 604.801.6577 &#13;
                    <div className="link-block">
                        <a href="https://www.google.ca/maps/place/Vancouver,+BC+V5Y+1J3/@49.2668423,-123.1124443,17z/data=!3m1!4b1!4m5!3m4!1s0x548673def5d9e1b3:0xb0dfd745dce6c0e4!8m2!3d49.2668261!4d-123.1102373"
                          target="_blank">
                          <i className="fi-map" />View Map</a>
                        <a href="mailto:info@relic.com">
                          <i className="fi-mail" />General Enquiries</a>
                        <a href="mailto:media@relic.com">
                          <i className="fi-mail" />Media Enquiries</a>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="bottom-two large-3 medium-4 small-12 columns">
                <section className="block block-block social-iconbar block-block-4">
                  <div className="icon-bar vertical">
                    <a href="https://twitter.com/relicgames" target="blank" className="item">
                      <i className="fi-social-twitter" />
                      <label>@relicgames</label>
                    </a>
                    <a href="https://www.facebook.com/relicentertainment" target="blank" className="item">
                      <i className="fi-social-facebook" />
                      <label>/RelicEntertainment</label>
                    </a>
                    <a href="https://instagram.com/relicentertainment/" target="blank" className="item">
                      <i className="fi-social-instagram" />
                      <label>@RelicEntertainment</label>
                    </a>
                    <a href="https://www.youtube.com/user/RelicCM" target="blank" className="item">
                      <i className="fi-social-youtube" />
                      <label>/RelicCM</label>
                    </a>
                    <a href="http://www.twitch.tv/relicentertainment" target="blank" className="item">
                      <i className="fi-twitch" />
                      <label>/RelicEntertainment</label>
                    </a>
                  </div>
                </section>
              </div>
              <div className="bottom-three large-3 show-for-large-up columns">
                <section className="block block-system sub-nav block-menu block-system-main-menu">
                  <ul className="menu">
                    <li className="first leaf">
                      <a onClick={e => onFooterLinkClick(e, timelineObj)} href="/#franchises" title="" className="active">Franchises</a>
                    </li>
                    <li className="leaf">
                      <a onClick={e => onFooterLinkClick(e, timelineObj)} href="/#studio" title="" className="active">The Studio</a>
                    </li>
                    <li className="leaf">
                      <a onClick={e => onFooterLinkClick(e, timelineObj)} href="/#history" title="" className="active">History</a>
                    </li>
                    <li className="leaf">
                      <a onClick={e => onFooterLinkClick(e, timelineObj)} href="/#careers" title="" className="active">Careers</a>
                    </li>
                    <li className="last leaf">
                      <a onClick={e => onFooterLinkClick(e, timelineObj)} href="/#news" title="" className="active">News</a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="footer small-12 small-centered column clearfix">
              <section className="block block-menu sub-nav block-menu-menu-footer-menu">
                <ul className="menu">
                  <li className="first leaf">
                    <a href="https://content.relic.com/legal/eula_terms.html" title="EULA &amp; Terms of Service | Relic Entertainment">EULA &amp; Terms of Service</a>
                  </li>
                  <li className="leaf">
                    <a href="https://content.relic.com/legal/privacypolicy.html" title="Privacy Policy | Relic Entertainment">Privacy Policy</a>
                  </li>
                  <li className="leaf">
                    <a href="https://help.relic.com/hc/en-us" title="Support | Relic Entertainment">Support</a>
                  </li>
                  <li className="last leaf">
                    <a href="https://content.relic.com/legal/cookiepolicy.html" title="Relic Cookie Policy">Cookie Policy</a>
                  </li>
                </ul>
              </section>
              <section className="block block-block block-block-3">
                <div className="logos">
                    <IconRelicLogoFull aria-label="Relic Entertainment logo" />
                    <IconEssence aria-label="Essence Engine logo" />
                    <img src={contentLoader('ESRB_2013_RP_to_Mature.png')} alt="ESRB logo" />
                </div>
              </section>
              <section className="block block-block block-block-5">
                <div id="loader" className="pageload-overlay" data-opening="M 0,0 80,-10 80,60 0,70 0,0" data-closing="M 0,-10 80,-20 80,-10 0,0 0,-10">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 80 60" preserveAspectRatio="none">
                    <path d="M 0,70 80,60 80,80 0,80 0,70" />
                  </svg>
                </div>
              </section>
            </div>
          </div>
          <div className="row">
            <div className="copyright small-12 small-centered column text-center">
              &copy; 2024 Relic Entertainment. All rights reserved. © The Relic Entertainment logo is a registered trademark of Relic Entertainment. 
              All rights reserved. All other trademarks are the property of their respective owners.
            </div>
          </div>
          <div className="row">
            <div className="footer-bottom small-12 small-centered column text-center">
              <section className="block block-views block-views-pictures-credits">
                <h2 className="block-title">Photograph attributions</h2>
                <div className="view view-pictures view-id-pictures view-display-id-credits view-dom-id-0cabf3844b36c622db22069b0b5a8c54">
                  <div className="view-header">
                    Flickr photos used courtesy of Flickr under the Creative Commons Attribution 2.0 Generic licence.
                  <a href="https://creativecommons.org/licenses/by/2.0/">https://creativecommons.org/licenses/by/2.0/.</a>.
                    <br />Studio photo 3 &amp; 4 © Stephen Mirowski </div>
                  <div className="view-content">
                    <div>
                      Mountain Biker © andy_c , 2012. </div>
                    <div>
                      Vancouver Skyline photo © Radius Images/Corbis. </div>
                    <div>
                      Pan Pacifica restaurant image © Pan Pacifica restaurant. </div>
                    <div>
                      Illuminate Yaletown © Totororo.roro </div>
                    <div>
                      Vancouver Canucks © Jeff Vinnick. </div>
                    <div>
                      Inuksuk and Black Tusk, Seventh Heaven © Ruth Hartnup. </div>
                    <div>
                      <p>Chinese Carnival © KIM LUDBROOK/epa/Corbis.</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Footer.jsx